import { useAtomValue } from "jotai";
import ReactLoading from "react-loading";

import { loadingAtom } from "@/states/loadingAtom";

import styles from "./index.module.scss";

type Props = {
  global?: boolean;
};

/* グローバルローディング */
const Loading: React.FC<Props> = ({ global }) => {
  const showLoading = useAtomValue(loadingAtom);
  return (
    <div className={global || showLoading ? styles.wrapper : styles.hide}>
      <ReactLoading
        className={styles.loading}
        type="bars"
        color="#fff"
        width="8rem"
        height="8rem"
      />
    </div>
  );
};

export default Loading;
